import React from 'react';

import { createRoot } from 'react-dom/client';

import PaymentModal from '../../components/container/PaymentModal/PaymentModal';

(() => {
    const element = document.querySelector('payment-modal');

    if (!element) return;

    createRoot(element).render(<PaymentModal {...element.dataset}/>);
})();
